<script setup lang="ts">
import type { NuxtError } from '#app';

const { t } = useEkI18n();

interface Props{
  error: NuxtError;

}

defineProps<Props>();

function handleError() {
  clearError({ redirect: '/' });
}

</script>

<template>
  <div class="container">
    <p class="statusCode">
      {{ error.statusCode }}
    </p>
    <p
      v-if="error.statusCode === 404"
      class="errorMessage"
    >
      {{ t('error.statusCode.404') }}
    </p>
    <p
      v-if="error.statusCode === 500"
      class="errorMessage"
    >
      {{ t('error.statusCode.500') }}
    </p>
    <p
      v-if="error.statusCode === 400"
      class="errorMessage"
    >
      {{ t('error.statusCode.400') }}
    </p>
    <p
      v-if="error.statusCode !== 404 && error.statusCode !== 400 && error.statusCode !== 500"
      class="errorMessage"
    >
      {{ t('error.statusCode.unknown') }} {{ error.message }}
    </p>
    <p class="standardMessage">
      {{ t('error.standardMessage') }} <br> <br>
      {{ t('error.phone') }}: {{ t('error.phoneNumber') }} <br><br> Mail: {{ t('error.mailAddress') }}
    </p>
    <IonButton
      expand="block"
      shape="round"
      fill="solid"
      size="default"
      @click="handleError"
    >
      {{ t('error.buttonPreviousPage') }}
    </IonButton>
  </div>
</template>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    padding-left: 30px;
    padding-right: 30px;
    background: linear-gradient(-45deg, rgba(23,34,47,1) 0%, rgba(57,73,85,1) 100%);
    text-align: center;
}
.statusCode {
    font-size: 6rem;
    font-weight: bold;
    margin: 0;
    color: #f9f9f9;
}
.errorMessage {
    font-size: 20px;
    margin: 0;
    color: white;
}

.standardMessage {
    font-size: 14px;
    margin-top: 30px;
    margin-bottom: 30px;
    padding-top: 10px;
    color: white;
    text-align: center;
}
</style>
